import React from 'react';

const VideoShimmer = ({ className = '', aspectRatio = '16/9' }) => {
  return (
    <div
      className={`relative overflow-hidden bg-gradient-to-r from-[#1A1C20] via-[#25272C] to-[#1A1C20] rounded-lg ${className}`}
      style={{ aspectRatio }}
    >
      {/* Animated shimmer overlay */}
      <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite]">
        <div className="h-full w-full bg-gradient-to-r from-transparent via-white/10 to-transparent" />
      </div>

      {/* Play button icon */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-16 h-16 rounded-full bg-white/5 flex items-center justify-center animate-pulse">
          <svg
            className="w-8 h-8 text-white/30"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path d="M8 5v14l11-7z" />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default VideoShimmer;
